import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import NoticeList from "../pages/Notices/NoticeList";
import CreateNotice from "../pages/Notices/CreateNotice";
import EditNotice from "../pages/Notices/EditNotice";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path={"/"} element={<NoticeList />} />
          <Route path={"/create"} element={<CreateNotice />} />
          <Route path={"/edit/:id"} element={<EditNotice />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={1000} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
